import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/pim/product-icons/not_deliverable.png'
import _imports_1 from '@/assets/images/pim/product-icons/image_available.png'
import _imports_2 from '@/assets/images/pim/product-icons/prescription.png'
import _imports_3 from '@/assets/images/pim/product-icons/medicine.png'
import _imports_4 from '@/assets/images/pim/product-icons/medical_aid.png'


const _hoisted_1 = { class: "icons d-flex" }
const _hoisted_2 = ["data-dp-tooltip"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "not deliverable"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["data-dp-tooltip"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "multi image"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["data-dp-tooltip"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "prescription"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["data-dp-tooltip"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "medicine"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["data-dp-tooltip"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "medicinal aid"
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.product.product_info.is_apb_out_of_business)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "me-1",
          "data-dp-tooltip": _ctx.$t('productNoLongerDeliverable'),
          "data-dp-position": "right"
        }, _hoisted_4, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.product.product_info.is_image_available)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "me-1",
          "data-dp-tooltip": _ctx.$t('imageAvailable'),
          "data-dp-position": "right"
        }, _hoisted_7, 8, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.product.product_info.is_prescription_required)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "me-1",
          "data-dp-tooltip": _ctx.$t('onPrescription'),
          "data-dp-position": "right"
        }, _hoisted_10, 8, _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.product.product_info.is_medicine)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "me-1",
          "data-dp-tooltip": _ctx.$t('registeredMedicine'),
          "data-dp-position": "right"
        }, _hoisted_13, 8, _hoisted_11))
      : _createCommentVNode("", true),
    (_ctx.product.product_info.is_medical_aid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "me-1",
          "data-dp-tooltip": _ctx.$t('registeredMedicalAid'),
          "data-dp-position": "right"
        }, _hoisted_16, 8, _hoisted_14))
      : _createCommentVNode("", true)
  ]))
}